import {Tag} from 'platform/components';
import {Show} from 'platform/foundation';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {useDebouncedValue} from 'shared/web';

export type AutosaveStatus = 'pristine' | 'saving' | 'error';

interface AutosaveIndicatorProps {
  status: AutosaveStatus;
}

// Delay before the "Saving…" tag appears. Quick autosaves resolve before this, so a filled task
// does not flash a tag on every answer — only a save that genuinely drags shows feedback.
const SAVING_INDICATOR_DELAY_MS = 500;

export function AutosaveIndicator(props: AutosaveIndicatorProps) {
  const isSaving = props.status === 'saving';
  const showSaving = useDebouncedValue(isSaving, SAVING_INDICATOR_DELAY_MS) && isSaving;

  return match(props.status)
    .with('pristine', () => null)
    .with('saving', () => (
      <Show when={showSaving}>
        <Tag label={i18n.t('page.recordAudit.form.indicator.saving')} colorScheme="blue" isSubtle />
      </Show>
    ))
    .with('error', () => (
      <Tag label={i18n.t('page.recordAudit.form.indicator.error')} colorScheme="red" />
    ))
    .exhaustive();
}
